/** Iniciais das 4 primeiras gerações (região → trio planta/fogo/água). */
export const STARTER_REGIONS = Object.freeze([
  {
    id: 'kanto',
    labelKey: 'starter.region.kanto',
    starters: [
      { slug: 'bulbasaur', dex: 1 },
      { slug: 'charmander', dex: 4 },
      { slug: 'squirtle', dex: 7 },
    ],
  },
  {
    id: 'johto',
    labelKey: 'starter.region.johto',
    starters: [
      { slug: 'chikorita', dex: 152 },
      { slug: 'cyndaquil', dex: 155 },
      { slug: 'totodile', dex: 158 },
    ],
  },
  {
    id: 'hoenn',
    labelKey: 'starter.region.hoenn',
    starters: [
      { slug: 'treecko', dex: 252 },
      { slug: 'torchic', dex: 255 },
      { slug: 'mudkip', dex: 258 },
    ],
  },
  {
    id: 'sinnoh',
    labelKey: 'starter.region.sinnoh',
    starters: [
      { slug: 'turtwig', dex: 387 },
      { slug: 'chimchar', dex: 390 },
      { slug: 'piplup', dex: 393 },
    ],
  },
]);

export const DEFAULT_STARTER_REGION = 'kanto';

export function regionById(id) {
  return STARTER_REGIONS.find((region) => region.id === id) || STARTER_REGIONS[0];
}

export function allStarterSlugs() {
  return STARTER_REGIONS.flatMap((region) => region.starters.map((s) => s.slug));
}

export function isValidStarterSlug(slug) {
  return allStarterSlugs().includes(slug);
}
